import { Route, Outlet } from 'react-router-dom';
import { ProtectedRoute } from 'ProtectedRoute';
import { hasReportsAccess } from 'Users';
import { type RouteRegistryEntry } from 'FrontRoyalRouteRegistry/FrontRoyalRouteRegistry.types';
import { ReportsComponent } from './components/ReportsComponent';

export const REPORTS_ROUTES = {
    REPORTS: { path: '/reports' },
};

export function configureReportsRoutes(): RouteRegistryEntry[] {
    return [
        {
            routes: REPORTS_ROUTES,
            config: {
                errorHandlingRules: 'reports',
            },
        },
    ];
}

export function getReportsRoutes() {
    return (
        <Route id="reports-routes" element={<Outlet />}>
            <Route
                path={REPORTS_ROUTES.REPORTS.path}
                element={
                    <ProtectedRoute
                        accessPolicy="custom"
                        accessPolicyFn={({ currentUser }) => hasReportsAccess(currentUser)}
                    >
                        <ReportsComponent />
                    </ProtectedRoute>
                }
            />
        </Route>
    );
}
